import config from "@/config.js";
const API_URL = `${config.ACCOUNTS_API_URL}ds-accounts-be`;
const RAZORPAY_ID = config.RAZORPAY_ID;

export function getTransaction(instance, transactionId) {
  const url = `${API_URL}/transaction/${transactionId}`;
  return new Promise((resolve, reject) => {
    instance.$http.get(url).then(
      res => {
        if (res.data.status) {
          return resolve(res.data.data);
        } else {
          return reject(res.data);
        }
      },
      err => reject(err.body)
    );
  });
}

export function getTransactionV2(instance, transactionId) {
  const url = `${API_URL}/v2/transaction/${transactionId}?with_platform_charges_setting=true`;
  return new Promise((resolve, reject) => {
    instance.$http.get(url).then(
      res => {
        if (res.data.status) {
          return resolve(res.data.data);
        } else {
          return reject(res.data);
        }
      },
      err => reject(err.body)
    );
  });
}

export function getOrderSummaryDetails(instance, searchParams) {
  const url = `${API_URL}/transaction/order-summary-details`;
  return new Promise((resolve, reject) => {
    instance.$http
      .get(url, {
        params: { ...searchParams }
      })
      .then(
        res => {
          if (res.data.status) {
            return resolve(res.data.data);
          } else {
            return reject(res.data);
          }
        },
        err => reject(err.body)
      );
  });
}

export function getPaymentHistory(instance, searchParams) {
  const url = `${API_URL}/transaction/payment-history-details`;
  return new Promise((resolve, reject) => {
    instance.$http
      .get(url, {
        params: { ...searchParams }
      })
      .then(
        res => {
          if (res.data.status) {
            return resolve(res.data.data);
          } else {
            return reject(res.data);
          }
        },
        err => reject(err.body)
      );
  });
}

export function searchTransactions(instance, searchParams) {
  const url = `${API_URL}/transaction/search`;
  return new Promise((resolve, reject) => {
    instance.$http
      .get(url, {
        params: {
          ...searchParams
        }
      })
      .then(
        res => {
          if (res.data.status) {
            return resolve(res.data.data);
          } else {
            return reject(res.data);
          }
        },
        err => reject(err.body)
      );
  });
}

export function getBalancePayable(instance, searchParams) {
  const url = `${API_URL}/transaction/balance-payable`;
  return new Promise((resolve, reject) => {
    instance.$http
      .get(url, {
        params: {
          ...searchParams,
          offset: 0,
          limit: 50
        }
      })
      .then(
        res => {
          if (res.data.status) {
            const balancePayable = res.data.data.balance_payable;
            return resolve(balancePayable);
          } else {
            return reject(res.data);
          }
        },
        err => reject(err.body)
      );
  });
}

export function getWalletBalance(instance, userId) {
  const url = `${API_URL}/v2/wallet/dashboard?belongs_to=${userId}`;
  return new Promise((resolve, reject) => {
    instance.$http.get(url).then(
      res => {
        if (res.data.status) {
          return resolve(res.data.data);
        } else {
          return reject(res.data);
        }
      },
      err => reject(err.body)
    );
  });
}

export function updateTransaction(instance, transactionId, body) {
  const url = `${API_URL}/transaction/${transactionId}`;
  return new Promise((resolve, reject) => {
    instance.$http.put(url, body).then(
      res => {
        if (res.data.status) {
          return resolve(res.data.data);
        } else {
          return reject(res.data);
        }
      },
      err => reject(err.body)
    );
  });
}

export function payBalance(instance, body) {
  const url = `${API_URL}/payment/add`;
  return new Promise((resolve, reject) => {
    instance.$http.post(url, body).then(
      res => {
        if (res.data.status) {
          return resolve(res.data);
        } else {
          return reject(res.data);
        }
      },
      err => reject(err.body)
    );
  });
}

export function validateCoupon(instance, code) {
  let url = `${API_URL}/couponCode/${code}/validate`;
  return new Promise((resolve, reject) => {
    instance.$http.get(url).then(
      res => {
        resolve(res.data);
      },
      err => reject(err.body)
    );
  });
}

export function payNow(
  instance,
  transactionId,
  successUrl = document.URL,
  failureUrl = document.URL,
  for_wallet = false,
  use_wallet = false,
  coupon_code = false,
  gstin = ""
) {
  // let url = `${API_URL}/payment/generate_url`;
  let url = `${API_URL}/v2/transaction/generate_url`;
  let body = {
    transaction_id: transactionId,
    success_url: successUrl,
    failure_url: failureUrl,
    for_wallet,
    use_wallet,
    coupon_code,
    gstin
  };
  return new Promise(function(resolve, reject) {
    instance.$http.post(url, body).then(
      res => {
        if (res.data.status) {
          if (res.data.data.status == "processing") {
            instance.$store.dispatch("general/hideLoading");
            const options = {
              currency: "INR",
              key: RAZORPAY_ID,
              amount: res.data.data.amount,
              name: "DocSmart",
              order_id: res.data.data.order_id,
              handler: function() {
                window.location = successUrl;
                getPaymentStatus(instance, res.data.data.id);
              }
            };
            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
            // window.location = res.data.data.url;
          } else {
            instance.$store.dispatch("general/hideLoading");
            window.location = successUrl;
            getPaymentStatus(instance, res.data.data.id);
            return resolve(res.data);
          }
        } else {
          return reject(res.data.error);
        }
      },
      error => {
        instance.$store.dispatch("general/hideLoading");
        return reject(error.body);
      }
    );
  });
}

function showPaymentSuccess(instance) {
  instance.$swal.fire("Great", "Your payment was successful", "success");
}
function showPaymentFailure(instance) {
  instance.$swal.fire(
    "Uh-ho",
    "Payment was not successful. If any money was deducted it will be refunded back in 5-7 working days",
    "error"
  );
}
export function getPaymentStatus(self, paymentId) {
  self.$http.get(`${API_URL}/payment/${paymentId}`).then(response => {
    let query = Object.assign({}, self.$route.query);
    delete query.id;
    self.$router.replace({ query });
    const { data: payment } = response.data;
    if (payment.status === "success") {
      showPaymentSuccess(self);
    } else {
      showPaymentFailure(self);
    }
  });
}

export function getPaymentStatusForSubscription(instance, paymentId) {
  const url = `${API_URL}/payment/${paymentId}`;
  return new Promise((resolve, reject) => {
    instance.$http.get(url).then(
      res => {
        if (res.body.status) {
          return resolve(res.body.data);
        } else {
          return reject(res.body.data);
        }
      },
      err => reject(err.body)
    );
  });
}

export function saveTransaction(instance, body, transactionId) {
  const url = `${API_URL}/v2/payment/${transactionId}`;
  return new Promise((resolve, reject) => {
    instance.$http.post(url, body).then(
      res => {
        if (res.data.status) {
          return resolve(res.data);
        } else {
          return reject(res.data);
        }
      },
      err => reject(err.body)
    );
  });
}
